import React from 'react';
import PropTypes from 'prop-types';

import VaultActivity from './vault_activity';

export default function PvpActivity({ compact, lead }) {
  const pvpActivities = lead.propertyVaultProfiles.map((propertyVaultProfile, i) => {
    return (
      <VaultActivity
        compact={compact}
        key={i}
        lead={lead}
        propertyVaultProfile={propertyVaultProfile}
      />
    );
  });

  return (
    <div>
      {pvpActivities}
    </div>
  );
}

PvpActivity.propTypes = {
  compact: PropTypes.bool,
  lead: PropTypes.shape({
    propertyVaultProfiles: PropTypes.arrayOf(
      PropTypes.shape({
        activityPath: PropTypes.string.isRequired,
        approvalState: PropTypes.string,
        approveAccessPath: PropTypes.string,
        inWaitlist: PropTypes.bool,
        revokeAccessPath: PropTypes.string
      })
    )
  })
};
